"use client"

import styled from "@emotion/styled"
import { AdvancedMarker } from "@vis.gl/react-google-maps"
import { MouseEvent as ReactMouseEvent } from "react"
import { PortItem } from "utils"
import { PortMapMarkerIcon } from "./icons"

const StyledMarker = styled.div<{ $selected?: boolean }>`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  svg {
    color: ${({ $selected }) => ($selected ? "#0E2846" : "#0000FA")};
    width: 55px;
    height: 67px;
    ${(props) => props.theme.breakpoints.up("md")} {
      width: 66px;
      height: 80px;
    }
  }
  &:hover {
    transform: scale(1.1);
    svg {
      color: #0e2846;
    }
  }
  span {
    position: absolute;
    bottom: 21px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;

    color: white;
    font-size: 10px;
    font-weight: 700;
    line-height: 125%; /* 15px */
    text-transform: capitalize;

    ${(props) => props.theme.breakpoints.up("md")} {
      bottom: 23px;
      font-size: 12px;
    }
  }
`

type PortMarkerProps = {
  port: PortItem
  position: { lat: number; lng: number }
  isSelected?: boolean
  // eslint-disable-next-line no-unused-vars
  onMarkerClick?: (port: PortItem) => void
}

const PortMarker = ({ port, position, isSelected = false, onMarkerClick }: PortMarkerProps) => {
  const handleClick = () => {
    if (onMarkerClick) {
      onMarkerClick(port)
    }
  }

  const handleMarkerClick = (
    // eslint-disable-next-line no-unused-vars
    event?: google.maps.MapMouseEvent | ReactMouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    handleClick()
  }

  return (
    <>
      <AdvancedMarker
        position={position}
        gmpClickable={false}
        onClick={handleMarkerClick}
        zIndex={isSelected ? 10 : 1}
      >
        <StyledMarker $selected={isSelected} onClick={handleMarkerClick}>
          <PortMapMarkerIcon color={isSelected ? "#0E2846" : "#0000FA"} />
          <span className="port-mapname">{port.mapName}</span>
        </StyledMarker>
      </AdvancedMarker>
    </>
  )
}

export default PortMarker
